export default __webpack_public_path__ + "static/media/preview-video.c0567592.jpg";